<template>
  <component
    :is="componentType"
    :method="props.method"
    :as="props.as"
    :href="href"
    class="font-medium"
    :class="classes"
    :target="target"
    :rel="rel"
  >
    <slot />
    <span
      v-if="props.arrow"
      class="delay-50 inline-block transition duration-300 ease-out group-hover:translate-x-0.5"
      aria-hidden="true"
      >&rarr;</span
    >
  </component>
</template>

<script setup>
import { Link } from '@inertiajs/inertia-vue3'
import { computed } from 'vue'
import { colorClasses } from '../util/colorMap'
import { hoverTextColorClasses } from './common'

const props = defineProps({
  href: {
    type: String,
  },
  method: {
    type: String,
    default: 'get',
  },
  as: {
    type: String,
    default: 'a',
  },
  color: {
    type: String,
    default: 'text-indigo-600',
  },
  size: {
    type: String,
    default: 'sm',
  },
  disabled: Boolean,
  external: Boolean,
  arrow: Boolean,
})

const componentType = computed(() => {
  if (props.disabled) return 'span'

  if (props.external) return 'a'

  return props.href ? Link : 'a'
})
const href = computed(() => (props.href ? props.href : '#'))

const sizeClasses = computed(() => {
  return {
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl',
  }[props.size]
})

const classes = computed(() => {
  return [
    props.color,
    colorClasses(props.color),
    sizeClasses.value,
    hoverTextColorClasses(props.color, props.disabled),
    props.arrow ? 'group' : null,
  ].join(' ')
})

const target = computed(() => (props.external ? '_blank' : null))
const rel = computed(() => (props.external ? 'noopener noreferrer' : null))
</script>
